import { c as _c } from "react/compiler-runtime";
import { useGet } from '@openclassrooms/data-connect-web/hooks';
import { useCurrentUserContext } from '@openclassrooms/data-connect-web/users';
import { StudentApplication } from '@openclassrooms/sdk-web';
export default function useAplOwner(t0) {
  const $ = _c(11);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    enabled: t2
  } = t1;
  const enabled = t2 === undefined ? true : t2;
  const {
    userId
  } = useCurrentUserContext();
  const t3 = Number(userId);
  let t4;
  if ($[2] !== t3) {
    t4 = {
      userId: t3
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = enabled && Boolean(userId);
  let t6;
  if ($[4] !== t4 || $[5] !== t5) {
    t6 = {
      routeParams: t4,
      enabled: t5
    };
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const {
    data,
    isFetching
  } = useGet("/users/:userId/student-applications", t6);
  const studentApplication = data?.body?.[0] as {
    owner?: Omit<NonNullable<StudentApplication['owner']>, 'supportChannel'>;
    supportChannel?: StudentApplication['supportChannel'];
  } | undefined;
  const t7 = studentApplication?.owner?.name ? studentApplication.owner : undefined;
  const t8 = studentApplication?.supportChannel;
  let t9;
  if ($[7] !== isFetching || $[8] !== t7 || $[9] !== t8) {
    t9 = {
      aplOwner: t7,
      supportChannel: t8,
      isLoading: isFetching
    };
    $[7] = isFetching;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  return t9;
}